import React, { useCallback, useEffect, useState } from 'react';

import ConfirmActionModal from 'adapter/in/common/components/ConfirmActionModal/ConfirmActionModal';

import useWidget from 'adapter/in/dashboards/context/Widget/data';
import i18n from 'asset/translation';
import { useCase } from 'adapter/in/common/hooks/useCase';
import { dispatchWidgetsView } from 'adapter/in/dashboards/context/Widgets/view';
import { isSome } from 'fp-ts/lib/Option';
import gtmIds from 'adapter/in/dashboards/config/gtm';
import { DeleteWidgetCriteriaBuilder } from 'use-case/widgets/delete/deleteWidgetCriteria';

const gtm = gtmIds.widget.deleteModal;

export const useOnDeleteWidgetModal = (dashboardId: string, widgetId: string) => {
    const { deleteWidget } = useWidget();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const { data, error, execute: remove, isLoading, reset } = useCase(deleteWidget, false);
    const { toggleReloadWidgets } = dispatchWidgetsView();

    const handleDelete = useCallback(
        () => remove(DeleteWidgetCriteriaBuilder.create().withDashboardId(dashboardId).withWidgetId(widgetId).build()),
        [dashboardId, widgetId]
    );

    const handleOnDelete = () => {
        setShowDeleteModal(true);
    };

    useEffect(() => {
        if (isSome(data)) {
            toggleReloadWidgets(true);
            reset();
            setShowDeleteModal(false);
        }
    }, [data]);

    const onDeleteModal = (
        <ConfirmActionModal
            isOpen={showDeleteModal}
            onClose={() => {
                setShowDeleteModal(false);
                reset();
            }}
            mainButton={handleDelete}
            mainButtonVariant='destructive'
            isLoading={isLoading}
            hasError={isSome(error)}
            mainButtonText={i18n.t('widgets.delete.yes')}
            message={i18n.t('widgets.delete.warningMsg')}
            title={i18n.t('widgets.actionDelete')}
            dataIdContext={{ main: gtm.actions.delete, cancel: gtm.actions.cancel, tryAgain: gtm.actions.tryAgain }}
        />
    );

    return { handleOnDelete, onDeleteModal };
};
